import React from 'react'
import { Link } from '@inertiajs/react'
import { ArrowRight } from 'lucide-react'
import { cx } from '@/lib/utils'
import styles from './ButtonLink.module.scss'

type Variant = 'primary' | 'secondary' | 'ghost'
type Size = 'sm' | 'md' | 'lg'

interface ButtonLinkProps {
  href: string
  children: React.ReactNode
  variant?: Variant
  size?: Size
  arrow?: boolean
}

const variantMap: Record<Variant, string> = {
  primary: styles.primary,
  secondary: styles.secondary,
  ghost: styles.ghost,
}

const sizeMap: Record<Size, string> = {
  sm: styles.sizeSm, md: styles.sizeMd, lg: styles.sizeLg,
}

export const ButtonLink: React.FC<ButtonLinkProps> = ({
  href, children, variant = 'primary', size = 'md', arrow = false,
}) => (
  <Link href={href} className={cx(styles.btn, variantMap[variant], sizeMap[size])}>
    {children}
    {arrow && <ArrowRight size={16} className={styles.arrow} />}
  </Link>
)
